import moment from 'moment'

export default {
    install: (app, options) => {
        app.config.globalProperties.$color = {
            'maincolor': '#3843AF',
            'labelcolor' : '#E71414',
        }
    }
}